import { StyleSheet } from 'react-native';




export const theme = {
  PRIMARY_FONT: {
    fontFamily: 'SeriouslyNostalgicFn-Cond',
    fontWeight: 300,
  },
  SECONDARY_FONT: {
    fontFamily: 'GTPressura-Light',
    fontWeight: 300,
  },
  TERTIARY_FONT: {
    fontFamily: 'PerfectlyNostalgicCondensedB-Co',
    fontWeight: 600
  },
  
  FONT_XSMALL: {
    fontSize: 10,
    lineHeight: 16,
    letterSpacing: -0.2,
    fontWeight: 500
  },
  FONT_SMALL: {
    fontSize: 14,
    lineHeight: 21,
  },
  FONT_MEDIUM: {
    fontSize: 16,
    lineHeight: 24,
  },
  FONT_LARGE: {
    fontSize: 20,
    lineHeight: 24,
  },
  FONT_XLARGE: {
    fontSize: 32,
    lineHeight: 40,
  },
  FONT_XXLARGE: {
    fontSize: 32,
    lineHeight: 40,
  },

  COLORS: {
    WHITE: "#ffffff",
    BLACK: "#000000",

    BACKGROUND_COLOR: '#FFFFFF', // background color for main containers
    BACKGROUND_COLOR_CONTRAST: '#1D1D1D',

    BACKGROUND_COLOR_SECONDARY: "#8E2C21", // secondary background color (eg: footer)
    BACKGROUND_COLOR_SECONDARY_CONTRAST: "#FFFFFF",

    PRIMARY_COLOR: "#FFFFFF", // primary color
    PRIMARY_TEXT_COLOR: "#1D1D1D", // primary text color

    SECONDARY_COLOR: "#8E2C21", // secondary color
    SECONDARY_TEXT_COLOR: "#FFFFFF", // secondary text color

    ACCENT_COLOR: "#D7BB8B",
    ACCENT_Text_COLOR: "#FFFFFF"
  },
};


export default StyleSheet.create({

  backText: {
    color: theme.COLORS.WHITE,
  },
  backIcon: {
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },

  promoWidgetContainer: {
    display: "none"
  },
  
  input: {
    borderRadius: null
  },
  secondaryBtn: {
    borderRadius: null
  },
  tertiaryBtn: {
    borderRadius: null
  },
  tertiaryBtnTxt: {
    color: theme.COLORS.SECONDARY_COLOR
  },
  headerContainer:{
    backgroundColor: theme.COLORS.BACKGROUND_COLOR_SECONDARY
  },
  headerContainerInnerCompRight:{
    // opacity: 0
  },
  notificationIcon:{
    filter: "invert(1)",
    tintColor: theme.COLORS.WHITE,
  },
  tabLabel:{
    fontSize: 12
  },
  "infoWidgetsWidgetContainer_heading-info-text": {
    // gap: 10,
    gap: null,
    paddingTop: 40,
    paddingBottom: 80,
    backgroundColor: "#E6DDCF",
  },
  "infoWidgetHeaderTitle_heading-info-text": {
    display: "flex",
    flexDirection: "column",
    fontSize: null,
  },
  "infoWidgetsWidgetContainer_heading-info-text-dining": {
        "gap": null,
        "paddingTop": 40,
        "paddingBottom": 40,
        "backgroundColor": "#E6DDCF"
  },
  "infoWidgetHeaderTitle_heading-info-text-dining": {
        "display": "flex",
        "flexDirection": "column",
        "fontSize": null
  },
  "bannerWidgetsWidgetContainer_pre-checkin": {
    paddingVertical: 8,
    backgroundColor:"#D7BB8B",
    borderRadius: 4,

    // iOS shadow
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 6,
  },
  "bannerWidgetImageStyle_pre-checkin":{
    display: "none"
  },
  "bannerWidgetTextContainer_pre-checkin":{
    paddingLeft: 16
  },

  "bannerWidgetMainContainer_pre-checkin":{
    top: -50,
    width: "100%",
    zIndex: 100,
    marginBottom: -50,
  },
  "bannerWidgetsWidgetContainer_guest-details":{
    paddingVertical: 8,
    backgroundColor:"#D7BB8B",
    borderRadius: 4,

    // iOS shadow
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 6,
  },
  "bannerWidgetImageStyle_guest-details":{
    display: "none"
  },
  "bannerWidgetTextContainer_guest-details":{
    paddingLeft: 16
  },

  "bannerWidgetMainContainer_guest-details":{
    top: -50,
    width: "100%",
    zIndex: 100,
    marginBottom: -50,
  },
  
  mainContainerHeaderTitleContainer: {
    display: "none"
  },

  bannerWidgetTitle: {
    ...theme.TERTIARY_FONT,
    textTransform: null,
  },
  mainContainerHeaderImg: {
    height: null
  },

  bannerWidgetDescription:{
    textTransform: null
  },
  billCheckoutContainer: {
    border: 0,
  },
  primaryBtn: {
    borderRadius: null,
  },

  mainContainerHeaderContainer: {
    display: "none"
  },


  welcomeScreenLogoStyle: {
    width: 309,
    height: 60,
    objectFit: "cover",
  }


});
